import { render, staticRenderFns } from "./BaseAlertSystem.vue?vue&type=template&id=0ff6cefa&"
import script from "./BaseAlertSystem.vue?vue&type=script&lang=js&"
export * from "./BaseAlertSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff6cefa')) {
      api.createRecord('0ff6cefa', component.options)
    } else {
      api.reload('0ff6cefa', component.options)
    }
    module.hot.accept("./BaseAlertSystem.vue?vue&type=template&id=0ff6cefa&", function () {
      api.rerender('0ff6cefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Alerts/BaseAlertSystem.vue"
export default component.exports